import { Button, Fieldset } from "@datapay-by-datacom/design-system";
import { useState } from "react";
import { Org, OrgKey } from "../../../generated/core-api";
import { useDeprovisionOrg } from "../../hooks";
import { OrgDeprovisionModal } from "./OrgDeprovisionModal";
import { useNavigate } from "react-router-dom";

interface OrgDeprovisionActionProps {
  org: Org;
}

export function OrgDeprovisionAction({ org }: OrgDeprovisionActionProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const deprovisionMutation = useDeprovisionOrg();
  const navigate = useNavigate();

  const handleDeprovision = () => {
    setIsModalOpen(true);
  };

  const handleConfirmDeprovision = (verificationText: string) => {
    const orgKey: OrgKey = {
      id: org.id,
      category: org.category,
    };

    deprovisionMutation.mutate(
      {
        orgKey,
        verificationText,
      },
      {
        onSuccess: () => {
          setIsModalOpen(false);
          // Redirect to org list after successful deprovisioning
          navigate("/org");
        },
      }
    );
  };

  return (
    <Fieldset>
      <Button variant="primary" onPress={handleDeprovision}>
        Deprovision Organization
      </Button>

      <OrgDeprovisionModal
        org={org}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleConfirmDeprovision}
        isPending={deprovisionMutation.isPending}
      />
    </Fieldset>
  );
}
